import { useSearchParams } from "react-router-dom";
import Button from "../components/Button";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const order = params.get("order");
  const isPaid = params.get("paid") === "1";
  const downloads = params.getAll("download").filter(Boolean);

  return (
    <section className="section success-page">
      <div className="container success-panel glass-card">
        <span className="eyebrow">{isPaid ? "Payment completed" : "Order confirmed"}</span>
        <h1>{isPaid ? "Your downloads are ready" : "Thank you"}</h1>
        <p>
          {order ? `Order ${order} has been received.` : "Your order has been received."}
          {" "}
          {isPaid
            ? "Your payment is confirmed. Your download link has also been sent by email."
            : "Once payment is confirmed, your download link will be emailed and shown in your account library."}
        </p>
        {downloads.length > 0 && (
          <div className="ebook-actions">
            {downloads.map((token, index) => (
              <Button key={token} to={`/download/${encodeURIComponent(token)}`}>
                {downloads.length === 1 ? "Download product" : `Download product ${index + 1}`}
              </Button>
            ))}
          </div>
        )}
        <div className="ebook-actions">
          <Button to="/account">Open Account</Button>
          <Button to="/shop" variant="secondary">Back to Shop</Button>
        </div>
      </div>
    </section>
  );
}
